import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-config-presorteo-create',
  templateUrl: './page-config-presorteo-create.component.html',
  styleUrls: ['./page-config-presorteo-create.component.scss']
})
export class PageConfigPresorteoCreateComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  goBack(): void {
    this.router.navigate(['presorteo/megaloto/config-presorteo']);
  }

}
